<template>
  <div id="batchReadings">
    <PageTitle :title="$t('batch_reading.d_title')" :subtitle="$t('batch_reading.d_subtitle')"></PageTitle>
    <div class="container">
      <Datatable class="datatable" :entity="entity" :parameters="parameters" :onRowClick="onRowClick" >
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/Datatable.vue";
import PageTitle from "@/components/PageTitle.vue";
export default {
  name: "BatchReadings",

  components: { Datatable, PageTitle },

  data() {
    return {
      entity: "batch",
      parameters: {
        company: this.$route.query.company
      }
    };
  },
  methods: {
    async onRowClick(row) {
      this.$router.push(this.$router.buildContext("/batch-reading/" + row.id, this.$route.query));
    }
  }
}
</script>

<style lang="scss" scoped>
  #batchReadings {
    display: flex;
    flex-direction: column;

    .datatable {
      flex-grow: 1;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }
</style>